if (!customElements.get('tabs-component')) {
  customElements.define(
    'tabs-component',
    class TabsComponent extends HTMLElement {
      constructor() {
        super();
        this.tabs = this.querySelectorAll('.tabs-title');
        this.contents = this.querySelectorAll('.tab-content');
      }

      connectedCallback() {
        this.tabs.forEach(tab => {
          tab.addEventListener('click', (event) => this.activateTab(event.currentTarget));
          tab.addEventListener('keydown', (event) => this.handleKeydown(event));
        });

        const activeTab = this.querySelector('.tabs-title.active');
        if (activeTab) {
          this.activateTab(activeTab, false);
        }
      }

      activateTab(tab, animate = true) {
        const tabId = tab.getAttribute('data-tab');
        const activeContent = this.querySelector(`.tab-content[data-tab-id="${tabId}"]`);

        if (!activeContent || activeContent.classList.contains('active')) return;

        this.tabs.forEach(t => t.classList.remove('active'));
        this.contents.forEach(c => this.slideUp(c, animate));

        tab.classList.add('active');
        this.slideDown(activeContent, animate);
      }

      slideDown(element, animate = true) {
        element.style.display = 'block';
        const height = element.scrollHeight + 'px';
        element.style.overflow = 'hidden';
        if (animate) {
          element.style.transition = 'height 0.4s ease, opacity 0.4s ease';
          element.style.height = '0px';
          element.style.opacity = '0';
          requestAnimationFrame(() => {
            element.style.height = height;
            element.style.opacity = '1';
          });
        } else {
          element.style.height = height;
          element.style.opacity = '1';
        }
        element.classList.add('active');

        setTimeout(() => {
          element.style.height = 'auto';
          element.style.overflow = 'visible';
        }, 400);
      }

      slideUp(element, animate = true) {
        if (!element.classList.contains('active')) return;

        element.style.overflow = 'hidden';
        const height = element.scrollHeight + 'px';
        element.style.height = height;

        if (animate) {
          requestAnimationFrame(() => {
            element.style.transition = 'height 0.4s ease, opacity 0.4s ease';
            element.style.height = '0px';
            element.style.opacity = '0';
          });

          setTimeout(() => {
            element.style.display = 'none';
            element.classList.remove('active');
            element.style.height = '';
            element.style.opacity = '';
            element.style.overflow = '';
          }, 400);
        } else {
          element.style.display = 'none';
          element.classList.remove('active');
        }
      }

      handleKeydown(event) {
        const key = event.key;
        let newIndex;
      
        const currentIndex = Array.from(this.tabs).indexOf(event.currentTarget);
      
        if (key === 'ArrowRight' || key === 'ArrowDown') {
          newIndex = (currentIndex + 1) % this.tabs.length;
          this.tabs[newIndex].focus();
          this.activateTab(this.tabs[newIndex]);
          event.preventDefault();
        } else if (key === 'ArrowLeft' || key === 'ArrowUp') {
          newIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
          this.tabs[newIndex].focus();
          this.activateTab(this.tabs[newIndex]);
          event.preventDefault();
        } else if (key === 'Enter' || key === ' ') {
          this.activateTab(event.currentTarget);
          event.preventDefault();
        }
      }
    }
  );
}
